import React from "react";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { useParams, Link } from "react-router-dom";
import { EVENT, PLAYER, VIDEO } from "../../constants";
import "./styles/event-details.scss";

function EventDetails({
  title,
  startTime,
  id,
  streamType,
  clientShortName,
  withLink
}) {
  const params = useParams();

  const evtTitleContent = (
    <span>
      {title}
      <Moment className="pl-1" format="L">
        {startTime}
      </Moment>
    </span>
  );

  const content = (
    <>
      <div className="d-flex">
        <span className="i-view-single" />
      </div>
      <div className="d-flex event-title">
        <b>
          {id && withLink ? (
            <Link
              to={`/${
                clientShortName || params.shortName
              }/${PLAYER}/${EVENT}/${id}/${streamType}`}
            >
              {evtTitleContent}
            </Link>
          ) : (
            evtTitleContent
          )}
        </b>
      </div>
    </>
  );

  return (
    <div className="d-flex align-items-start event-details-container">
      {content}
    </div>
  );
}

EventDetails.defaultProps = {
  id: 0,
  streamType: VIDEO,
  clientShortName: "",
  withLink: false
};

EventDetails.propTypes = {
  title: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  id: PropTypes.number,
  streamType: PropTypes.string,
  clientShortName: PropTypes.string,
  withLink: PropTypes.bool
};

export default EventDetails;
